import { call, put, fork, select, take } from 'redux-saga/effects';
import { dataAction }             from 'apps/actions/data';
import { plannerAction }          from 'apps/actions/planner';
// import { addMessage }         from 'apps/actions/message';
import { newDataFromDot }     from 'utilities/hash';
import { deepmerge }          from 'utilities/merge';

export const connect = function(settings){
  return function* (action){
    let { data, error } = yield call(settings.apiMethod, action.payload);
    if(error || data.error){
      let notify = {
        error: {
          text: App.store.getState().data.locale.commons.error_500,
          type: 'alert'
        }
      };
      yield put(dataAction.update({data: { notify: notify }}));
    } else {
      if(!data.data){ data['data'] = {};}
      if(action.payload.scope){
        console.log("scope is " + action.payload.scope)
        let updatedData = newDataFromDot({updated_at: new Date().getTime()}, action.payload.scope);
        data.data = deepmerge(updatedData, data.data);
      }
      if(data.memos){     yield put(plannerAction.memos(data.memos)); }
      if(data.locations){ yield put(plannerAction.locations(data.locations)); }
      if(data.taskables){ yield put(plannerAction.taskables(data.taskables)); }
      if(data.tasks){     yield put(plannerAction.tasks(data.tasks)); }
      if(data.schedules){ yield put(plannerAction.schedules(data.schedules)); }
      if(data.lines){     yield put(plannerAction.lines(data.lines)); }
      if(data.orders){    yield put(plannerAction.orders(data.orders)); }
      if(data.planner){   yield put(plannerAction.update(data.planner)); }
      yield put(dataAction.update(data.data));
    }
  }
}
